import invokeCallback from './utils/invokeCallback';
import selectEventByDispId from './utils/selectEventByDispId';
import { ApiEvent } from './schema/ApiEvent';
import { ApiEventCallback } from './schema/ApiEventCallback';
import { getApiEventHandler } from './storage/ActiveApiEvents';
import { OutlookEventDispId } from './schema/OutlookEventDispId';
import {
    getHandlerNotRegisteredResult,
    getSuccessResult,
    ApiEventResult,
    isSuccess,
} from './schema/ApiEventResult';

export default function triggerApiEvent(
    dispId: OutlookEventDispId,
    controlId: string,
    args: any,
    callback?: ApiEventCallback
) {
    const apiEvent = selectEventByDispId(dispId);
    let result = apiEvent.onTrigger(args, controlId);
    if (isSuccess(result)) {
        result = invokeHandler(controlId, dispId, apiEvent, args);
    }

    invokeCallback(callback, result);
}

function invokeHandler(
    controlId: string,
    dispId: OutlookEventDispId,
    apiEvent: ApiEvent,
    args: any
): ApiEventResult {
    const handler = getApiEventHandler(controlId, dispId);
    if (!handler) {
        return getHandlerNotRegisteredResult();
    }

    const formattedArgs = apiEvent.formatArgsForHandler(args);
    handler(formattedArgs);
    return getSuccessResult();
}
